import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-item-img as-group as-show-full"
}
const _hoisted_2 = { class: "as-group-imgs" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "as-item-badge" }
const _hoisted_5 = { class: "as-item-badge-num" }
const _hoisted_6 = {
  key: 1,
  class: "as-item-img"
}
const _hoisted_7 = { class: "as-d-inline-flex" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "as-item-badge" }
const _hoisted_11 = { class: "as-item-badge-num" }
const _hoisted_12 = {
  key: 0,
  class: "as-item-badge-flag"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "as-item-info as-show-full"
}
const _hoisted_15 = {
  key: 3,
  class: "as-item-info"
}

import { computed } from "vue";
import type { IMatch, IMatchTennis } from "~src/interfaces/tennis";


const __default__ = {};

interface IProps {
  match: IMatch | IMatchTennis;
  team: any;
  country: string;
  scores: string | number | any;
  mode?: string;
  modeTeam?: string;
  session?: string;
  modifyClass?: string;
  logo?: string;
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PlayerTennisNew',
  props: {
    match: {},
    team: {},
    country: {},
    scores: { default: "20" },
    mode: { default: "tennis" },
    modeTeam: { default: "" },
    session: { default: "" },
    modifyClass: { default: "" },
    logo: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const sub_ids = computed(() => {
  return props.team?.sub_ids ?? "";
});

const names = computed(() => {
  return props.team?.name.split("/");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-wrapper-player as-wrapper-player__item ${_ctx.modeTeam} ${_ctx.modifyClass}`)
  }, [
    (sub_ids.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sub_ids.value, (sub, key) => {
              return (_openBlock(), _createElementBlock("img", {
                key: key,
                class: _normalizeClass(["as-img-player", `team-logo-${key}`]),
                src: _ctx.getImgUrlBySport('team', sub)
              }, null, 10, _hoisted_3))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.scores), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.logo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "as-img-player",
                  src: _ctx.logo
                }, null, 8, _hoisted_8))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "as-img-player",
                  src: _ctx.getImgUrlBySport('team', _ctx.team.id)
                }, null, 8, _hoisted_9))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.scores), 1),
            (_ctx.country)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("img", {
                    class: "as-img-badge-flag",
                    src: _ctx.country
                  }, null, 8, _hoisted_13)
                ]))
              : _createCommentVNode("", true)
          ])
        ])),
    (sub_ids.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(names.value, (_name, key) => {
            return (_openBlock(), _createElementBlock("span", { key: key }, _toDisplayString(_name), 1))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("span", null, _toDisplayString(_ctx.team.name), 1)
        ]))
  ], 2))
}
}

})